import { useTranslation } from 'react-i18next'
import {
    ModalWrapper, Modal, ModalTop, SearchIcon, ModalTitle, Input
} from './styles'
import searchIcon from './../../../assets/search.svg';
import { forwardRef } from 'react';



const MasterSearch = forwardRef(
    (props, ref) => {
        const { t } = useTranslation();

        return (
            <ModalWrapper ref={ref}> 
                <Modal>
                    <ModalTop>
                        <SearchIcon alt='search' src={searchIcon} />
                        <ModalTitle>
                            {t('searchMaster')}
                        </ModalTitle>
                    </ModalTop>
                    <Input onChange={(e) => {props.onChange(e.currentTarget.value)}}/>
                </Modal>
            </ModalWrapper>
        )
    }
)

export default MasterSearch;